<template>
  <section v-if="notifications.length" :class="$style.notifications">
    <v-snackbar value="true" top right :timeout="-1" vertical>
      <Notification
        v-for="notification in notifications"
        :key="notification.id"
        v-bind="notification"
        @remove="removeNotification"
        @dismiss-dialog="dismissAll"
      />
      <template #action="{ attrs }">
        <!-- <BaseButton :disabled="messagesPending" small v-bind="attrs">
          {{ $t('general.close') }}
        </BaseButton> -->

        <v-btn small class="mt-2 btn" rounded :elevation="0" v-bind="attrs" @click="dismissAll">{{
          $t('general.close')
        }}</v-btn>
      </template>
    </v-snackbar>
  </section>
</template>

<script>
import { pick } from 'lodash-es'
import { mapState, mapActions } from 'vuex'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import APP_ACTIONS from '@/js/plugins/store/modules/app/action-types.js'
import APP_CONSTANTS from '@/js/plugins/store/modules/app/constants.js'

import Notification from '@/js/components/Notifications/Notification.vue'

export default {
  name: 'Notifications',
  components: { Notification },
  computed: {
    ...mapState(STOREMODULES.APP, {
      notifications: APP_CONSTANTS.NOTIFICATIONS,
    }),
  },
  methods: {
    ...mapActions(STOREMODULES.APP, {
      removeNotification: APP_ACTIONS.REMOVE_NOTIFICATION,
    }),
    dismissAll() {
      this.removeNotification(this.notifications.map(notification => pick(notification, ['id'])))
    },
  },
}
</script>

<style lang="scss" module>
.notifications {
  font-size: var(--font-base);
  font-family: var(--font-sans);
  // :global(.v-snack__wrapper) {
  //   margin-left: 0;

  //   border-top-left-radius: 0;
  //   border-bottom-left-radius: 0;
  // }

  :global(.v-snack) {
    max-height: calc(100vh - 200px);
  }

  :global(.v-snack__wrapper) {
    max-height: 100%;
  }

  :global(.v-snack__content) {
    padding-right: 0;
    // scrollbar-width: thin;
    padding-left: 0.55rem;
    overflow-y: scroll;
    scrollbar-color: var(--primary) transparent; /* scroll thumb and track */

    &::-webkit-scrollbar-track {
      background-color: transparent;
      // border-radius: 10px;
      // -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }

    &::-webkit-scrollbar {
      width: 10px;

      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: var(--primary);
      // border: 2px solid transparent;
      border-radius: 10px;
    }
  }

  :global(.v-snack__wrapper.theme--dark) {
    background: rgba(var(--black-rgba), 0.85);
  }

  :global(.v-snack__content) {
    width: 100%;
  }
}
</style>
